import React, { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import SearchBar from '../../../Components/Utils/SearchBar'
import { ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton } from '../../../Components/Utils/Buttons'
import { GetAccess } from '../../../Components/Utils/roles'
import Breadcrumb from '../../../Components/Utils/Breadcrumb'

const InvoiceLayout = (
    {
        getData=() => {},
        setSearchQuery=()=>{},
        CreateAccess= false,
        ImportAccess= false,
        setOpen=()=>{},
        children,
        onCreateClick,
        searchValue="",
        searchFun=()=>{},
        isFilter=false,
        setFilterOpen=()=>{},
        newfilter=false,
        ClearFilter=()=>{},
        neededSearch=false,
        showproject=true,
        isCard=true,
        setViewMode=()=>{},
            viewMode="",
            ExportAccess=false,
        setOpenExport=()=>{},
    }
) => {
    let {pathname} = useLocation()
    let {officeId,projecTId} = useParams()
    
    const [module,setModule] = useState("")
    
    useEffect(() =>{
         if(pathname == `/invoice/invoice-outgoing`){
            setModule("Outgoing")
        }
        else{
            setModule("Invalid")
        }
    },[pathname])

    let LinkItem = [
       
       
        {
            label:"Outgoing",
            link:`/invoice/invoice-outgoing`,
            access:true,
        },
       
       
          ]
    
    return(
        <div className=" w-full  h-full pt-2 px-4 overflow-hidden">
            <div className="">
            <div className="md:flex justify-between w-full ">
             <Breadcrumb
                              items={[
                                { name: "Invoice" },
                               
                    
                                { name: module },
                              ]}
                            />

            
           

            <div className=" flex justify-end items-center gap-3 ">
            <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
            <SearchBar handleChange={searchFun}  value={searchValue}/>

            </form>
              <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
              {isFilter&& <ClearFilterButton label='Clear Filter'  handleClick={ClearFilter} />} 
               {/* {ImportAccess && <ImportButton label="Import" handleClick={()=>setOpen(true)}    />}
                               {ExportAccess && <ExportButton label="Export" handleClick={()=>setOpenExport(true)}    />} */}
                

              {/* {CreateAccess && <Link to={`${pathname}/create`}><CreateButton label={module}/></Link>} */}
                  {/* <BackButton/> */}
                </div>
            </div>

            <div className=" w-full  flex items-center gap-x-1 ">
            {
                LinkItem && LinkItem.map((item, i) => {
      const isActive = item?.link === pathname;

                    return(
                        <>
                         {
                            item.access && (

                                <Link
                                                                                               to={item?.link}
                                                                                               key={item?.link}
                                                                                               className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                                                                                                 ${isActive 
                                                                                                   ? "bg-baseColor-primary text-white" 
                                                                                                   : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                                                                                                 }`}
                                                                                             >
                                                                                               {item?.label || ""} 
                                                                                             </Link>
                                                    // <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>
                                // <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>

                                     )
                         }
                        </>
                    )
                })
            }
        </div>
           
            
            <div className=" w-full h-[calc(100vh-140px)]  ">
               {children} 
            </div>
            </div>
        </div>
    )
}

export default InvoiceLayout
